"use client";

import { useEffect } from "react";

export default function OutboundLinkTracker() {
  useEffect(function setup() {
    function onClick(event: MouseEvent) {
      const target = event.target as Element | null;
      if (!target) return;
      const anchor = (target.closest && target.closest("a")) as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = anchor.getAttribute("href") || "";
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:"))
        return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) {
          window.dispatchEvent(
            new CustomEvent("analytics", {
              detail: { event: "outbound_click", url: url.toString() },
            })
          );
        }
      } catch {
        // ignore invalid URLs
      }
    }
    document.addEventListener("click", onClick);
    return function cleanup() {
      document.removeEventListener("click", onClick);
    };
  }, []);
  return null;
}
